import bootbox from 'bootbox';

window.unsaved_changes = false;

$(document).ready(function(e){
    let is_edit_create_page = $('.create-field').length,
        changed = false,
        $clicked_item = '';

    if(is_edit_create_page){
        $('.create-update-fields').find('input:not(.sub_chk, .check_all, #check_all, #default-value, #change_background, #change_table), textarea').keyup(function(e){
            window.unsaved_changes = true;
            $(this).addClass('unsaved-changed');
        });

        $('.create-update-fields').find('select:not(#alert-type, #event-option)').change(function(e){
            window.unsaved_changes = true;
            $(this).addClass('unsaved-changed');
        });

        $(document).on('click', 'a', function(e){
            let edit_record = $('.create-update-fields').find('.unsaved-changed').length,
                editing = $('.browse-table').find('.custom-value-edit').length,
                edit_relations = $('.browse-table').find('.editable-td.update').length;

            if( $(e.target).hasClass('edit-td') || $(e.target).attr('data-allow') === 'yes'){
                return;
            }

            if(e.target.id !== 'CreateSaveAndNew' &&
                e.target.id !== 'CreateSave' &&
                e.target.id !== 'find-company' &&
                !$(this).hasClass('save-record-only') &&
                !$(this).hasClass('nav-link') &&
                !$(this).hasClass('init-send-email') &&
                !$(this).hasClass('editable-container') &&
                !$(this).hasClass('print-template') &&
                !$(this).hasClass('tmp-preview') &&
                !$(this).hasClass('execute-button-action') &&
                !$(this).hasClass('send-email') &&
                !$(this).hasClass('dropbtn') &&
                !$(this).hasClass('edit-td') &&
                !$(this).hasClass('delete-related-data') &&
                !$(this).hasClass('relation-link') &&
                !$(this).hasClass('upload-image') &&
                !$(this).hasClass('trigger-edit') &&
                !$(this).hasClass('toggle-section-collapse') &&
                !$(this).hasClass('nav-action-btn') &&
                !$(this).is('[role="option"]') &&
                !$(this).hasClass('popup-relation-link') &&
                !$(this).hasClass('apply-section-filter') &&
                !$(this).hasClass('apply-related-filter') &&
                !$(this).hasClass('show-attachment-modal') &&
                !$(this).parents('.relation-row').length &&
                !$(this).hasClass('relation-filter-icon')
            ) {
                console.log( window.unsaved_changes, edit_record,  editing, edit_relations);
                if(window.unsaved_changes || edit_record || editing || edit_relations){
                    e.preventDefault();
                    $clicked_item = $(this);

                    bootbox.dialog({
                        message: `<p>${translation.crud_dialog}</p>`,
                        size: 'large',
                        onEscape: true,
                        backdrop: true,
                        buttons: {
                            save: {
                                label: `${translation.save}`,
                                className: 'btn-primary',
                                callback: function(){
                                    let force_redirect = $($($clicked_item)[0]).attr('href');
                                    $('input[name="force_redirect"]').val(force_redirect);
                                    $('.save-edit').trigger('click');
                                    $('#CreateSave').trigger('click');
                                }
                            },
                            dontSave: {
                                label: `${translation.dont_save}`,
                                className: 'btn-primary',
                                callback: function(){
                                    changed = false;
                                    $('.cancel-edit').trigger('click');
                                    $($($clicked_item)[0]).attr('data-allow', 'yes');
                                    $($clicked_item)[0].click();
                                }
                            },
                            Cancel: {
                                label: `${translation.cancel}`,
                                className: 'btn-primary',
                                callback: function(){

                                }
                            },
                        }
                    })
                }
            }
        });

        // $('.cancel-draft').on('click', function(e){
        //     e.preventDefault();
        //
        //     let url = $(this).attr('href'),
        //         id = $(this).attr('data-id'),
        //         table_id = $(this).attr('data-table-id');
        //
        //     bootbox.dialog({
        //         message: `<p>${translation.crud_draft_dialog}</p>`,
        //         size: 'large',
        //         onEscape: true,
        //         backdrop: true,
        //         buttons: {
        //             save: {
        //                 label: `${translation.save}`,
        //                 className: 'btn-primary',
        //                 callback: function(){
        //                     $('input[name="force_redirect"]').val(url);
        //                     $('.save-edit').trigger('click');
        //                     $('#CreateSave').trigger('click');
        //                 }
        //             },
        //             delete: {
        //                 label: `${translation.dont_save}`,
        //                 className: 'btn-primary',
        //                 callback: function(){
        //
        //                     $.ajax({
        //                         type : 'DELETE',
        //                         url : `/draft/${id}`,
        //                         data : {
        //                             table_id,
        //                         },
        //                         success : function(res){
        //                             if(res){
        //                                 window.location = url;
        //                             }
        //                         }
        //                     });
        //                 }
        //             },
        //         }
        //     })
        // });
    }
});